/**
 * Created by fajar on 04/11/2018.
 *
 * Config for constant string property (not environment)
 */

export default Object.freeze({
    'PREVIEW_FORMAT_DATE_COMMENT': 'D MMMM YYYY, hh:mm',
    'GOLANG_FORMAT_DATE': 'YYYY-MM-D', // 2023-04-06T08:25:34.289Z
    'GOLANG_SAVE_FORMAT_DATE': 'YYYY-MM-DD',
    'PREVIEW_FORMAT_DATE': 'D MMMM YYYY',
    'PREVIEW_FORMAT_DATE_FULL': 'DD MMMM YYYY',
    'PREVIEW_SIMPLE_FORMAT_DATE': 'D-M-YYYY',
    'COMPLETE_FORMAT_DATE': 'D MMMM YYYY, hh:mm A',
    'POST_PUT_FORMAT_DATE': 'MMM DD, YYYY hh:mm:ss A',
    'SEARCH_FORMAT_DATE': 'YYYY-MM-D',
    'TIME_FORMAT': 'hh:mm',
    'MONTH_NAME': 'MMMM',
    'ONE_SIGNAL_APP_ID': '6f73477e-f567-463f-90b0-2e1350ab4ae7',
    'ONE_SIGNAL_SAFARI_ID': 'web.onesignal.auto.48d9c6a2-4943-4221-b17b-a4e235bf1c7d',
    'STATUS': {
        'HTTP': {
            'UNAUTHORIZED': 401,
            'INTERNAL_SERVER_ERROR': 500
        },
        'API': {
            'DEFAULT_ERROR': '0000',


            'SUCCESS': 200,
            'SAVE_SUCCESS': '0010',
            'UPDATE_SUCCESS': '0013',
            'DELETE_SUCCESS': '0014',
            'UPLOAD_SUCCESS': '0017',

            'LOGIN_SUCCESS': '1101',

            'OPERATION_COMPLETE': '1112',

            'SAVE_DATA_EXIST': '0011',
            'UPDATE_FAILED': '0012',
            'DELETE_FAILED': '0015',
            'UPLOAD_FAILED': '0016',
            'CONNECTION_FAILED': '0018',
            'SYSTEM_EXCEPTION': '0019',
            'DB_EXCEPTION': '0020',
            'DATA_NOT_FOUND': '0021',
            'DATA_EXCEED_LIMIT': '0022',
            'ILLEGAL_ACCESS': '0023',

            'LOGIN_FAILED': '1102',
            'PASSWORD_OR_USER_NOT_REGISTERED': '1103',
            'USER_EXIST': '1104',
            'SESSION_EXPIRED': '1105',
            'PASSWORD_NOT_VALID': '1106',
            'TOKEN_NOT_VALID': '1107',

            'INPUT_NOT_VALID': '1111',
            'OPERATION_FAILED': '1113',

            'MAIL_EXIST': '1201',
            'MAIL_NOT_FOUND': '1202',
            'USERNAME_EXIST': '1203',

            'VALID_CODE': '1301',
            'INVALID_CODE': '1302',
        }
    },
    'ROLES': {
        'ADMIN': 'ADMIN',
    },
    'WILAYAH': {
        'AL-GHAZHIER': 'GHAZHIER',
        'AL-JADIED PUTRA': 'JADIED_PA',
        'MISYKAT AL NURAIN PUTRA': 'MISYKAT_PA',
        'MISYKAT AL NURAIN PUTRI': 'MISYKAT_PI',
        'AL-JADIED PUTRI': 'JADIED_PI',
        'AL-NASHIR AL-MANSHUR': 'AL_NASHIR',
        'AS-SYIFA': 'AS_SYIFA',
        'DAR EL SHOFA': 'EL_SHOFA',
        'MADINATUS SHOLAWAT': 'MADINATUS',
        'AZ-ZAHRA': 'AZ_ZAHRA',
    },
    'PENDIDIKAN': {
        'PUTRA': 'PP. KHAS PUTRA',
        'PUTRI': 'PP. KHAS PUTRI',
        'MISYKAT_PA': 'MISYKAT AL-NURAIN PUTRA',
        'MISYKAT_PI': 'MISYKAT AL-NURAIN PUTRI',
        'MTS': 'MTs KHAS Kempek',
        'SMP': 'SMP KHAS Kempek',
        'MA': 'MA KHAS Kempek',
        'SMK': 'SMK KHAS Kempek',
        'STIES': 'STIES KHAS Kempek',
        'STIKES': 'STIKES KHAS Kempek',
    },
    'PENDIDIKAN_FORMAL': {
        'MTS': 'MTs KHAS Kempek',
        'SMP': 'SMP KHAS Kempek',
        'MA': 'MA KHAS Kempek',
        'SMK': 'SMK KHAS Kempek',
        'STIES': 'STIES KHAS Kempek',
        'STIKES': 'STIKES KHAS Kempek',
    },
    'PENDIDIKAN_NON_FORMAL': {
        'PUTRA': 'PP. KHAS PUTRA',
        'PUTRI': 'PP. KHAS PUTRI',
        'MISYKAT_PA': 'MISYKAT AL-NURAIN PUTRA',
        'MISYKAT_PI': 'MISYKAT AL-NURAIN PUTRI',
    },
    'DAY': {
        'Minggu': 'Minggu',
        'Senin': 'Senin',
        'Selasa': 'Selasa',
        'Rabu': 'Rabu',
        'Kamis': 'Kamis',
        "Jum'at": "Jum'at",
        'Sabtu': 'Sabtu',
    },
    'MONTH': {
        'Januari': '1',
        'Februari': '2',
        'Maret': '3',
        'April': '4',
        'Mei': '5',
        'Juni': '6',
        'Juli': '7',
        'Agustus': '8',
        'September': '9',
        'Oktober': '10',
        'November': '11',
        'Desember': '12',
    },
    'MONTH_PEMBAYARAN': {
        'Juli': '1',
        'Agustus': '2',
        'September': '3',
        'Oktober': '4',
        'November': '5',
        'Desember': '6',
        'Januari': '7',
        'Februari': '8',
        'Maret': '9',
        'April': '10',
        'Mei': '11',
        'Juni': '12',
    },
    'VALID_TYPE': {
        'SEMUA BULAN': 'SEMUA BULAN',
        'BULAN INI': 'BULAN INI',
    },
    'OPERASI_HONOR': {
        'TETAP': 'TETAP',
        'HADIR_HARIAN': 'HADIR HARIAN',
        'KJM_MINGGU': 'KJM MINGGU',
        'TATAP_MUKA': 'TATAP MUKA',
    },
    'APPROVE_TYPE': {
        'KEUANGAN': 'KEUANGAN',
        'BENDAHARA': 'BENDAHARA',
        'KEPALA': 'KEPALA',
    },
    'APPROVE': {
        'BARU': 'BARU',
        'PROSES': 'PROSES',
        'SELESAI': 'SELESAI',
        'TOLAK': 'TOLAK',
        'ABAIKAN': 'ABAIKAN',
    },
    'COLORS_APPROVE': {
        'BARU': 'info',
        'PROSES': 'primary',
        'SELESAI': 'success',
        'TOLAK': 'danger',
        'ABAIKAN': 'default',
    },
    'SOAL': {
        'START': 'START',
        'RESET': 'RESET',
        'STOP': 'STOP',
    },
    'SIKAP': {
        'SPIRITUAL': 'SPIRITUAL',
        'SOSIAL': 'SOSIAL',
    },
    'DESKRIPSI_TYPE_RANGKING': {
        'RANKING': 'RANKING',
        'OPTION': 'OPTION',
    },
    'ASPEK_NILAI': {
        'PENGETAHUAN': 'PENGETAHUAN',
        'EKSTRAKURIKULER': 'EKSTRAKURIKULER',
        'KETERAMPILAN': 'KETERAMPILAN',
        'KETIDAKHADIRAN': 'KETIDAKHADIRAN',
        'SIKAP': 'SIKAP',
        'CATATAN_TANGGAPAN': 'CATATAN_TANGGAPAN',
        'PRESTASI': 'PRESTASI',
    },
    'COLORS': {
        'STATUS_PENGERJAAN': {
            'SEMUA': "#3091EC",
            'SELESAI': "#23d160",
            'BELUM': "#ff3860",
        },
        'STATUS_ABSENS': {
            "H": "#23d160",
            "S": "#3F51B5",
            "I": "#3273dc",
            "A": "#ff3860",
            "T": "#ffdd57",
            "B": "#ff0005",
            "D": "#209cee",
            "NY": "#c4c4c4"
        },
        "KELAS": {
            "X": '#3091EC',
            "XI": '#5D7DF5',
            "XII": '#B552E2',
        },
        "TRANSAKSI": {
            "LUNAS": "#008800",
            "BELUM": "#A40000",
        },
        'PENDAPATAN': {
            "H": "#23d160",
            "S": "#3F51B5",
            "I": "#3273dc",
            "A": "#ff3860",
            "T": "#ffdd57",
            "B": "#ff0005",
            "D": "#209cee",
            "NY": "#c4c4c4",
            "H1": "#23d160",
            "S2": "#3F51B5",
            "I3": "#3273dc",
            "A4": "#ff3860",
            "T5": "#ffdd57",
            "B6": "#ff0005",
            "D7": "#209cee",
            "9": "#c4c4c4",
            "90": "#23d160",
            "11": "#3F51B5",
            "12": "#3273dc",
            "13": "#ff3860",
            "T3": "#ffdd57",
            "B4": "#ff0005",
            "D5": "#209cee",
            "N6": "#c4c4c4"
        },
    }
});
